import React from "react";
import moment from "moment-timezone";
import { TimePicker as AntdTimePicker } from "antd";

const TimePicker = ({
  defaultOpenValue,
  format = "HH:mm",
  value,
  onChange,
  ...props
}) => (
  <AntdTimePicker
    placeholder={null}
    allowClear={false}
    {...props}
    defaultOpenValue={defaultOpenValue && moment(defaultOpenValue, format)}
    value={value && moment(value, format)}
    format={format}
    onChange={value => onChange(value.format(format))}
  />
);

export default TimePicker;
